import { Navigate } from 'react-router-dom';

function MissingRoute() {
    // pathname can be change based on what url you want to redirect to
    return < Navigate to={{pathname: '/flash-cards'}} />
}

export default MissingRoute
